import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import {
  LogisticsCalendarEvent,
  LogisticsProposal,
  LogisticsVacationsProposal
} from '@app/entities/models/manage-vacations/logistics-manage-vacations.model';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

export interface LogisticsManageVacationsRepository {
  getProposals(): Observable<LogisticsVacationsProposal>;
  getVacationsCriteria(): Observable<ManageVacationsCriteria>;
  getVacationsSeason(): Observable<VacationsSeason>;
  getCalendar(): Observable<SeasonCalendar<TUserTypeCalendarProposal>>;
  getDayDetail(day: string): Observable<LogisticsCalendarEvent[]>;
  createProposal(
    holidays: LogisticsProposal[],
    freeByHolidays: LogisticsProposal[],
    isDraft: boolean
  ): Observable<LogisticsVacationsProposal>;
  updateObservations(observations: string): Observable<EmployeeObservations>;
}

export const LOGISTICS_MANAGE_VACATIONS_REPOSITORY = new InjectionToken<LogisticsManageVacationsRepository>(
  'LOGISTICS_MANAGE_VACATIONS_REPOSITORY'
);
